"use client";

import React, { useEffect } from "react";

import { ErrorBoundary as SentryErrorBoundary } from "@stadium/services/error-reporting/error-boundary";
import { handle401 } from "@stadium/helpers/src/error-handler";

import { axiosInstance, axiosGraphqlInstance, axiosUsersGraphqlInstance } from "@services/axios";

import styles from "./main.module.scss";

const ErrorFallback = () => (
  <div className={styles.pageContainer}>
    <section className="text-center">
      <h2 className={styles.subTitle}>Something went wrong!</h2>
      <p className={styles.subText}>
        Our team has been notified. Meanwhile, you may refresh the page or try again.
      </p>
    </section>
  </div>
);

export default function ErrorBoundary({ children, ...props }) {
  useEffect(() => {
    [axiosInstance, axiosGraphqlInstance, axiosUsersGraphqlInstance].forEach((instance) => {
      instance.interceptors.request.use(
        (response) => response,
        (error) => handle401(error),
      );
    });
  }, []);

  const showDialog = (() => {
    if (typeof window === "undefined") {
      return false;
    }
    try {
      return !!window.localStorage.getItem("sentry-dialog");
    } catch (error) {
      return false;
    }
  })();
  return (
    <SentryErrorBoundary showDialog={showDialog} fallback={<ErrorFallback />} {...props}>
      {children}
    </SentryErrorBoundary>
  );
}
